import { cn } from 'app/lib/utils'
import {
    DuoChartBar1,
    DuoCompetitionStage,
    DuoGamepad1,
    DuoGlobe,
    DuoLayout4Blocks,
    DuoLayoutGrid,
    DuoLayoutHorizontal,
    DuoUser,
    DuoUserTeam,
    MedalStarCircle
} from 'components/icons/duotone'
import {
    AlertTriangle,
    Check,
    ChevronDown,
    ChevronLeft,
    ChevronRight,
    ChevronUp,
    Copy,
    Eye,
    Info,
    LucideIcon,
    Trash2,
    Trophy,
    Star
} from 'lucide-react'
import { IconBaseProps } from 'react-icons'
import { BsThreeDotsVertical } from 'react-icons/bs'
import {
    FaApplePay,
    FaBars,
    FaCalendarDays,
    FaFileLines,
    FaGlobe,
    FaGooglePay,
    FaLink,
    FaLock,
    FaPaypal,
    FaPen,
    FaStripe,
    FaTrash
} from 'react-icons/fa6'
import { FiUploadCloud } from 'react-icons/fi'
import { GoPlus } from 'react-icons/go'
import { IoIosArrowForward, IoIosArrowUp, IoMdCheckmarkCircle } from 'react-icons/io'
import { LiaTimesSolid } from 'react-icons/lia'
import { LuLayoutDashboard, LuLoaderCircle } from 'react-icons/lu'
import { MdOutlineSaveAlt } from 'react-icons/md'
import { PiPackageThin } from 'react-icons/pi'
import { RiLoader4Fill, RiVerifiedBadgeFill } from 'react-icons/ri'

export const IconCustomGoldPremium = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
    const defaultClasses =
        'size-[22px] bg-gradient-to-br from-yellow-400 via-yellow-500 to-amber-600 group-hover:from-yellow-300 group-hover:via-yellow-400 group-hover:to-amber-500 transition-all duration-700'

    const combinedClasses = cn(defaultClasses, className)

    return (
        <div className='relative size-fit'>
            <div
                className={combinedClasses}
                style={{
                    maskImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'%3e%3cpath d='M10.007 2.10377C8.60544 1.65006 7.08181 2.28116 6.41156 3.59306L5.60578 5.17023C5.51004 5.35763 5.35763 5.51004 5.17023 5.60578L3.59306 6.41156C2.28116 7.08181 1.65006 8.60544 2.10377 10.007L2.64923 11.692C2.71404 11.8922 2.71404 12.1078 2.64923 12.308L2.10377 13.993C1.65006 15.3946 2.28116 16.9182 3.59306 17.5885L5.17023 18.3942C5.35763 18.49 5.51004 18.6424 5.60578 18.8298L6.41156 20.407C7.08181 21.7189 8.60544 22.35 10.007 21.8963L11.692 21.3508C11.8922 21.286 12.1078 21.286 12.308 21.3508L13.993 21.8963C15.3946 22.35 16.9182 21.7189 17.5885 20.407L18.3942 18.8298C18.49 18.6424 18.6424 18.49 18.8298 18.3942L20.407 17.5885C21.7189 16.9182 22.35 15.3946 21.8963 13.993L21.3508 12.308C21.286 12.1078 21.286 11.8922 21.3508 11.692L21.8963 10.007C22.35 8.60544 21.7189 7.08181 20.407 6.41156L18.8298 5.60578C18.6424 5.51004 18.49 5.35763 18.3942 5.17023L17.5885 3.59306C16.9182 2.28116 15.3946 1.65006 13.993 2.10377L12.308 2.64923C12.1078 2.71403 11.8922 2.71404 11.692 2.64923L10.007 2.10377ZM6.75977 11.7573L8.17399 10.343L11.0024 13.1715L16.6593 7.51465L18.0735 8.92886L11.0024 15.9999L6.75977 11.7573Z'/%3e%3c/svg%3e")`,
                    WebkitMaskImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'%3e%3cpath d='M10.007 2.10377C8.60544 1.65006 7.08181 2.28116 6.41156 3.59306L5.60578 5.17023C5.51004 5.35763 5.35763 5.51004 5.17023 5.60578L3.59306 6.41156C2.28116 7.08181 1.65006 8.60544 2.10377 10.007L2.64923 11.692C2.71404 11.8922 2.71404 12.1078 2.64923 12.308L2.10377 13.993C1.65006 15.3946 2.28116 16.9182 3.59306 17.5885L5.17023 18.3942C5.35763 18.49 5.51004 18.6424 5.60578 18.8298L6.41156 20.407C7.08181 21.7189 8.60544 22.35 10.007 21.8963L11.692 21.3508C11.8922 21.286 12.1078 21.286 12.308 21.3508L13.993 21.8963C15.3946 22.35 16.9182 21.7189 17.5885 20.407L18.3942 18.8298C18.49 18.6424 18.6424 18.49 18.8298 18.3942L20.407 17.5885C21.7189 16.9182 22.35 15.3946 21.8963 13.993L21.3508 12.308C21.286 12.1078 21.286 11.8922 21.3508 11.692L21.8963 10.007C22.35 8.60544 21.7189 7.08181 20.407 6.41156L18.8298 5.60578C18.6424 5.51004 18.49 5.35763 18.3942 5.17023L17.5885 3.59306C16.9182 2.28116 15.3946 1.65006 13.993 2.10377L12.308 2.64923C12.1078 2.71403 11.8922 2.71404 11.692 2.64923L10.007 2.10377ZM6.75977 11.7573L8.17399 10.343L11.0024 13.1715L16.6593 7.51465L18.0735 8.92886L11.0024 15.9999L6.75977 11.7573Z'/%3e%3c/svg%3e")`,
                    maskRepeat: 'no-repeat',
                    WebkitMaskRepeat: 'no-repeat',
                    maskSize: 'contain',
                    WebkitMaskSize: 'contain',
                    maskPosition: 'center',
                    WebkitMaskPosition: 'center',
                    ...props.style
                }}
                {...props}
            />
        </div>
    )
}

export const IconOrganisationPremium = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
    const defaultClasses =
        'size-7 bg-gradient-to-br from-yellow-400 via-yellow-500 to-amber-600 group-hover:from-yellow-300 group-hover:via-yellow-400 group-hover:to-amber-500 transition-all duration-700'

    const combinedClasses = cn(defaultClasses, className)

    return (
        <div className='relative size-fit'>
            <div
                className={combinedClasses}
                style={{
                    maskImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'%3e%3cpath d='M2.91312 11.6739C3.23584 10.1953 3.53865 8.80805 2 6.5L5.5 2.5C5.5 2.5 9 4 12 1.5C15 4 18.5 2.5 18.5 2.5L22 6.5C20.4612 8.8081 20.7641 10.1954 21.0868 11.674C21.3933 13.0781 21.7177 14.5645 20.5 17C19.3425 19.315 17.3478 20.1227 15.4849 20.877C14.1289 21.4261 12.8428 21.9469 12.0003 23C11.1577 21.9469 9.8715 21.4261 8.51549 20.8771C6.65245 20.1227 4.65758 19.315 3.50001 17C2.28218 14.5645 2.60663 13.078 2.91312 11.6739ZM14.3776 12.7725L16.7552 10.4549L13.4694 9.97746L11.9999 7L10.5304 9.97746L7.24463 10.4549L9.62227 12.7725L9.06098 16.0451L11.9999 14.5L14.9388 16.0451L14.3776 12.7725Z'/%3e%3c/svg%3e")`,
                    WebkitMaskImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'%3e%3cpath d='M2.91312 11.6739C3.23584 10.1953 3.53865 8.80805 2 6.5L5.5 2.5C5.5 2.5 9 4 12 1.5C15 4 18.5 2.5 18.5 2.5L22 6.5C20.4612 8.8081 20.7641 10.1954 21.0868 11.674C21.3933 13.0781 21.7177 14.5645 20.5 17C19.3425 19.315 17.3478 20.1227 15.4849 20.877C14.1289 21.4261 12.8428 21.9469 12.0003 23C11.1577 21.9469 9.8715 21.4261 8.51549 20.8771C6.65245 20.1227 4.65758 19.315 3.50001 17C2.28218 14.5645 2.60663 13.078 2.91312 11.6739ZM14.3776 12.7725L16.7552 10.4549L13.4694 9.97746L11.9999 7L10.5304 9.97746L7.24463 10.4549L9.62227 12.7725L9.06098 16.0451L11.9999 14.5L14.9388 16.0451L14.3776 12.7725Z'/%3e%3c/svg%3e")`,
                    maskRepeat: 'no-repeat',
                    WebkitMaskRepeat: 'no-repeat',
                    maskSize: 'contain',
                    WebkitMaskSize: 'contain',
                    maskPosition: 'center',
                    WebkitMaskPosition: 'center',
                    ...props.style
                }}
                {...props}
            />
        </div>
    )
}

// New icon exports added at the bottom of the file
export const IconAlertTriangle = (props: IconBaseProps) => <AlertTriangle {...props} />
export const IconThreeDots = (props: IconBaseProps) => <BsThreeDotsVertical {...props} />
export const IconInfo = (props: IconBaseProps) => <Info {...props} />
export const IconTimes = (props: IconBaseProps) => <Info {...props} />

export const IconCheckmark = (props: IconBaseProps) => <Check {...props} />

export const IconCircleCheckmark = (props: IconBaseProps) => <IoMdCheckmarkCircle {...props} />

export const IconClose = ({ className }: { className?: string }) => <LiaTimesSolid className={className} />

export type { LucideIcon }

export const IconArrowUp = ({ className }: { className?: string }) => {
    return (
        <div className='size-7 relative'>
            <IoIosArrowUp className={cn('size-7', className)} />
        </div>
    )
}

export const IconSave = ({ className }: { className?: string }) => {
    return (
        <div>
            <MdOutlineSaveAlt className={cn('size-7', className)} />
        </div>
    )
}

export const IconCloud = ({ className }: { className?: string }) => {
    return (
        <div>
            <FiUploadCloud className={cn('size-7', className)} />
        </div>
    )
}

export const IconOrganisation = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoLayout4Blocks />
        </div>
    )
}
export const IconEmpty = ({ size = 7 }: { size?: number }) => {
    return (
        <div className={`size-${size} relative`}>
            <PiPackageThin className={`size-${size}`} />
        </div>
    )
}

export const IconLoading = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <LuLoaderCircle className='w-5 h-5 animate-spin' />
        </div>
    )
}

export const IconFederation = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoGlobe />
        </div>
    )
}
export const IconTeam = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoUserTeam />
        </div>
    )
}
export const IconCompetition = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoCompetitionStage />
        </div>
    )
}
export const IconPlayer = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoUser />
        </div>
    )
}
export const IconPlayerHub = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoLayout4Blocks />
        </div>
    )
}
export const IconStats = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoChartBar1 />
        </div>
    )
}
export const IconAwards = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <MedalStarCircle />
        </div>
    )
}
export const IconRankings = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoChartBar1 />
        </div>
    )
}
export const IconAdmin = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoUser className='size-7 -mt-0.5' />
        </div>
    )
}
export const IconTable = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoLayout4Blocks />
        </div>
    )
}
export const IconMatches = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoGamepad1 />
        </div>
    )
}
export const IconTOTW = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoLayoutGrid />
        </div>
    )
}
export const IconTOTS = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <DuoLayoutHorizontal />
        </div>
    )
}

export const IconPOTWMOTM = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <Trophy className='w-5 h-5' />
        </div>
    )
}

export const IconPOTW = () => (
    <div className='-ml-1 size-7 relative -mb-2'>
        <Trophy className='w-5 h-5' />
    </div>
)

export const IconMOTM = () => (
    <div className='-ml-1 size-7 relative -mb-2'>
        <Star className='w-5 h-5' />
    </div>
)

export const IconSeason = () => {
    return (
        <div className='-ml-1 size-7 relative'>
            <FaCalendarDays className='w-5 h-5' />
        </div>
    )
}
export const IconCalendar = () => {
    return (
        <div className='-ml-1 -mb-1 size-6 relative'>
            <FaCalendarDays className='w-5 h-5' />
        </div>
    )
}
export const IconEdit = ({ className }: { className?: string }) => {
    return <FaPen className={cn(`w-5 h-5`, className)} />
}
export const IconDelete = ({ className }: { className?: string }) => {
    return <FaTrash className={cn(`h-5`, className)} />
}
export const IconAdd = ({ className }: { className?: string }) => {
    return <GoPlus className={cn(`size-6`, className)} />
}
export const IconLayoutDashboard = () => {
    return <LuLayoutDashboard className='size-5' />
}
export const IconLock = () => {
    return <FaLock className='w-5 h-5' />
}

/** Lock icon for premium-gated features. Use when a feature requires premium. */
export const IconPremiumLock = ({ className, ...props }: React.SVGAttributes<SVGElement>) => {
    return <FaLock className={cn('text-yellow-500 text-lg', className)} {...props} />
}
export const IconPremium = (props: IconBaseProps) => {
    return <RiVerifiedBadgeFill {...props} />
}

export const IconLogs = () => {
    return <FaFileLines className='w-5 h-5' />
}
export const IconNavigateBack = (props: IconBaseProps) => {
    return <ChevronLeft className={cn('size-7 relative', props.className)} {...props} />
}

export const IconNavigateForward = (props: IconBaseProps) => {
    return <ChevronRight className={cn('size-7 relative', props.className)} {...props} />
}

export const IconNavigateUp = () => {
    return <ChevronUp className='size-7 relative' />
}

export const IconNavigateArrowForward = () => {
    return <IoIosArrowForward className='size-7 relative' />
}

export const IconNavigateDown = () => {
    return <ChevronDown className='size-7 relative' />
}

export const IconDiscord = () => {
    return <FaLink className='w-5 h-5' />
}

export const IconHamburgerMenu = () => {
    return <FaBars className='w-5 h-5' />
}

export const IconGooglePay = () => {
    return <FaGooglePay className='size-10' />
}

export const IconApplePay = () => {
    return <FaApplePay className='size-10' />
}

export const IconPaypal = () => {
    return <FaPaypal className='size-5' />
}

export const IconStripe = () => {
    return <FaStripe className='size-10' />
}

export const IconLink = ({ className }: { className?: string }) => {
    return <FaGlobe className={cn('size-6', className)} />
}

export const IconLoader = () => {
    return <RiLoader4Fill className='size-6 animate-spin' />
}

export const IconEye = ({ className, size }: { className?: string; size?: number }) => {
    return <Eye className={className} size={size} />
}

export const IconTrash = ({ className, size }: { className?: string; size?: number }) => {
    return <Trash2 className={className} size={size} />
}

export const IconDuplicate = ({ className }: { className?: string }) => {
    return <Copy className={cn('h-5 w-5', className)} />
}

export const IconFromText = ({ text }: { text: string }) => {
    const components: { [key: string]: React.ComponentType<any> } = {
        organisations: IconOrganisation,
        federations: IconFederation,
        competitions: IconCompetition,
        seasons: IconSeason,
        rankings: IconRankings,
        teams: IconTeam,
        players: IconPlayer,
        discord: IconDiscord,
        matches: IconMatches,
        external: IconLink
    }
    const Component = components[text.toLowerCase()]
    if (!Component) return null
    return <Component />
}
